import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import Participants from "./Participants";
import { updateViewState } from "../../../store/Slices/ViewManagerSlice";
import { RxCross1 } from "react-icons/rx";
import { useIsGroupCall } from "../../../hooks/useIsGroupCall";
import { useCallChrome } from "./CallChromeContext";
import TextTranslate from "../../../utils/TextTranslate";

/** Group-only participants drawer (chat is opened via Controlls → /chat). */
export default function ChatAndParticipents() {
  const dispatch = useAppDispatch();
  const ConnectedUser = useAppSelector((state) => state.ConnectedUser);
  const open = useAppSelector((state) => state.ViewManager.show_chat_in_call);
  const isGroupCall = useIsGroupCall();
  const { headerVisible } = useCallChrome();
  const headerTop = headerVisible ? "4rem" : "0rem";
  const panelHeight = headerVisible ? "calc(100dvh - 4rem)" : "100dvh";

  const close = () => dispatch(updateViewState({ show_chat_in_call: false }));

  if (!isGroupCall) return null;

  return (
    <>
      <div
        className={`fixed inset-x-0 bottom-0 z-30 bg-black/60 backdrop-blur-sm transition-all duration-500 ease-out lg:bg-black/30 ${
          open ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
        }`}
        style={{ top: headerTop }}
        aria-hidden={!open}
        onClick={close}
      />

      <div
        className={`fixed right-0 z-40 flex w-full max-w-md flex-col overflow-hidden border-l border-borderColor bg-primary shadow-2xl transition-all duration-500 ease-out sm:rounded-l-3xl 2xl:max-w-lg ${
          open
            ? "pointer-events-auto translate-x-0"
            : "pointer-events-none translate-x-full"
        }`}
        style={{ top: headerTop, height: panelHeight }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Participants"
      >
        <div className="flex items-center justify-between border-b border-borderColor px-4 py-3 pr-14">
          <div className="text-[15px] font-semibold text-darkText">
            <TextTranslate text="Participants" /> ({ConnectedUser.length})
          </div>
          <button
            type="button"
            aria-label="Close"
            onClick={close}
            className="absolute right-3 top-3 z-20 grid h-9 w-9 place-content-center rounded-lg border border-borderColor bg-secondary text-darkText shadow-md transition hover:scale-105 hover:bg-themeColor hover:text-primary focus:outline-none focus:ring-2 focus:ring-themeColor/60"
          >
            <RxCross1 className="text-base" />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden">
          <Participants />
        </div>
      </div>
    </>
  );
}
